import { FormEvent, useEffect, useState } from 'react';
import { api, Company, Contact } from '../api';
import { ErrorBox, Field, SourceBadge } from '../components/ui';

export type ContactInput = Partial<Pick<Contact, 'company_id' | 'first_name' | 'last_name' | 'email' | 'phone' | 'position' | 'addressing' | 'tags' | 'summary'>>;
const nn = (v: string) => (v.trim() === '' ? null : v.trim());

export function ContactForm({ initial, onSubmit, onCancel, error, busy, hideCompany }: {
  initial?: Contact; onSubmit: (v: ContactInput) => void; onCancel?: () => void; error?: unknown; busy?: boolean; hideCompany?: boolean;
}) {
  const [v, setV] = useState({
    last_name: initial?.last_name ?? '', first_name: initial?.first_name ?? '', email: initial?.email ?? '', phone: initial?.phone ?? '',
    position: initial?.position ?? '', addressing: initial?.addressing ?? 'magaz', company_id: initial?.company_id ?? '',
    tags: (initial?.tags ?? []).join(', '), summary: initial?.summary ?? '',
  });
  const [companies, setCompanies] = useState<Company[]>([]);
  useEffect(() => { if (!hideCompany) api<{ items: Company[] }>('/companies?limit=200').then((r) => setCompanies(r.items)).catch(() => undefined); }, [hideCompany]);
  const set = (k: keyof typeof v) => (e: { target: { value: string } }) => setV({ ...v, [k]: e.target.value });
  const fs = initial?.field_sources ?? {};
  const submit = (e: FormEvent) => {
    e.preventDefault();
    onSubmit({
      last_name: v.last_name.trim(), first_name: nn(v.first_name), email: nn(v.email), phone: nn(v.phone), position: nn(v.position),
      addressing: v.addressing as 'tegez' | 'magaz', tags: v.tags.split(',').map((t) => t.trim()).filter(Boolean), summary: nn(v.summary),
      ...(hideCompany ? {} : { company_id: v.company_id || null }),
    });
  };
  return (
    <form className="form" onSubmit={submit}>
      <div className="grid2">
        <Field label="Vezetéknév *"><input value={v.last_name} onChange={set('last_name')} required /></Field>
        <Field label="Keresztnév"><input value={v.first_name} onChange={set('first_name')} /></Field>
        <Field label="E-mail"><input type="email" value={v.email} onChange={set('email')} /><SourceBadge src={fs.email} /></Field>
        <Field label="Telefon"><input value={v.phone} onChange={set('phone')} placeholder="+36 30 123 4567" /><SourceBadge src={fs.phone} /></Field>
        <Field label="Pozíció"><input value={v.position} onChange={set('position')} /><SourceBadge src={fs.position} /></Field>
        <Field label="Megszólítás">
          <select value={v.addressing} onChange={set('addressing')}><option value="magaz">magázás</option><option value="tegez">tegezés</option></select>
        </Field>
        {!hideCompany && (
          <Field label="Cég">
            <select value={v.company_id} onChange={set('company_id')}>
              <option value="">– nincs –</option>
              {companies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </Field>
        )}
        <Field label="Címkék" hint="vesszővel elválasztva"><input value={v.tags} onChange={set('tags')} /></Field>
      </div>
      <Field label="Összefoglaló"><textarea rows={2} value={v.summary} onChange={set('summary')} /></Field>
      <ErrorBox error={error} />
      <div className="actions">
        <button type="submit" disabled={busy}>Mentés</button>
        {onCancel && <button type="button" className="secondary" onClick={onCancel}>Mégse</button>}
      </div>
    </form>
  );
}
